import { isOwner, isSupport } from "helpers/userHelpers";
import { redirect } from "react-router";
import store from "redux/store";

export const isOwnerOrSupportLoader = async () => {
  const permissions = store.getState().session.session?.permissions ?? [];
  const isOwnerOrSupport = isOwner(permissions) || isSupport(permissions);

  return isOwnerOrSupport ? null : redirect("..");
};
